import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { DefinitionTerm } from './DefinitionTerm';

export interface DefinitionListProps {
  termTextAlign?: 'left' | 'right';
}

/**
 * A styled Definition List. Specify items in the list by passing one or more `DefinitionListItem`
 * components as children.
 */
export const DefinitionList = styled('dl')<DefinitionListProps>((props) =>
  css({
    display: 'table',
    borderSpacing: '8px',
    margin: -1,
    [`${DefinitionTerm}`]: {
      textAlign: props.termTextAlign || 'right',
    },
  }),
);
